export default "__VITE_ASSET__DKgLxqcG__"